import { useMutation, useQueryClient } from "@tanstack/react-query";
import { matchesApi } from "../../api/matches";
import { matchKeys } from "../queries/useMatch";
import { tournamentKeys } from "../queries/useTournament";

export const useSetMatchResult = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: matchesApi.setResult,
    onSuccess: (_data, { matchId }) => {
      queryClient.invalidateQueries({ queryKey: tournamentKeys.all });
      queryClient.invalidateQueries({ queryKey: matchKeys.detail(matchId) });
    },
  });
};
